import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// FAQ data pour la facturation OPCO
const faqItems = [
  {
    id: 1,
    title: "Transmission directe des factures CFA",
    content: "Connectez-vous aux OPCO et transmettez vos factures d'apprentissage sans ressaisie manuelle",
    details: [
      "Interface directe avec les systèmes OPCO pour un envoi sécurisé",
      "Suivi du statut de traitement de chaque facture en temps réel",
      "Génération automatique des documents d'accompagnement requis",
      "Tableau de bord unifié pour piloter toute votre facturation",
    ]
  },
  {
    id: 2,
    title: "Pilotage des échéanciers de paiement",
    content: "Centralisez le suivi de vos créances et anticipez vos encaissements",
    details: [
      "Import automatique des plannings de paiement depuis vos OPCO partenaires",
      "Synchronisation quotidienne pour une vision actualisée",
      "Dashboard de trésorerie avec prévisions d'encaissement",
      "Notifications proactives pour les retards de paiement",
    ]
  },
  {
    id: 3,
    title: "Attestations de fin de formation",
    content: "Produisez automatiquement les justificatifs de réalisation exigés par les financeurs",
    details: [
      "Création automatisée des attestations dès la finalisation du parcours",
      "Calcul précis des heures réalisées basé sur vos données d'émargement",
      "Respect des formats et mentions obligatoires par OPCO",
    ]
  },
  {
    id: 4,
    title: "Gestion des coûts complémentaires",
    content: "Facturez facilement vos prestations annexes selon vos propres règles de gestion",
    details: [
      "Paramétrage flexible des frais additionnels selon vos besoins",
      "Choix libre des périodes de facturation pour chaque prestation",
      "Interface intuitive conçue pour simplifier vos processus administratifs",
      "Intégration transparente dans vos flux de facturation existants",
    ]
  },
];

const SolutionFacturation = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Galerie d'images */}
          <div className={styles.leftContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/DashboardFacturation.png"
                      alt="Interface d'export des feuilles"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              {/* Éléments flottants autour */}
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInLeft" 
                offset={300}
                style={{
                  position: 'absolute',
                  top: '10%',
                  left: '5%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/graph-facturation.png"
                  alt="Export par email"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-10%',
                  right: '5%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/factuIllus.png"
                  alt="Export PDF"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>

          {/* Côté droit - Texte et FAQ */}
          <div className={styles.rightContent}>
            <h2 className={cn("h2", styles.title)}>
              Maîtrisez vos flux financiers
            </h2>
            <div className={styles.info}>
              Pilotez l'intégralité de vos relations financières avec les organismes de financement depuis une plateforme centralisée et connectée.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default SolutionFacturation;
